export default function petSpaceForm() {
  function petSpaceFormSelect() {
    $('section.pet-space-send div.animal div.container-select-block ul.container-select-list li').click(function() {
      $('section.pet-space-send div.feed.cat').hide()
      $('section.pet-space-send div.feed.dog').hide()
      var value = $(this).attr('data-send')
      var valueInput = $(this).data('send')
      var input = $(this)
      var trimmedValue = value.trim()
      if (trimmedValue === 'gato') {
        if (window.innerWidth > 1025) {
          $('section.pet-space-send div.feed.cat').css('display', 'grid')
        } else {
          $('section.pet-space-send div.feed.cat').css('display', 'flex')
        }
      } else if (trimmedValue === 'cao') {
        if (window.innerWidth > 1025) {
          $('section.pet-space-send div.feed.dog').css('display', 'grid')
        } else {
          $('section.pet-space-send div.feed.dog').css('display', 'flex')
        }
      }
      setTimeout(() => {
        input
          .closest('.container-select-block')
          .find('input.select-input.pet-send')
          .val(valueInput)
          .trigger('change')
          .attr('value', valueInput)
      }, 200)
    })
  }
  petSpaceFormSelect()
  $(window).resize(function() {
    petSpaceFormSelect()
  })

  $('section.pet-space-send div.feed.cat input.select-input').change(function() {
    $('section.pet-space-send div.more-information').fadeIn()
  })

  $('section.pet-space-send div.feed.dog input.select-input').change(function() {
    $('section.pet-space-send div.more-information').fadeIn()
  })
}
